<template>
    <div style="background: #fff" v-loading="pdfLoading">
        <div class="box" v-if="showResult&&hasFinished">
            <h1 class="serviceTestTitle">EOB Exam</h1>
            <!--
            <span>Of the parts of this exam that can be automatically graded you have recieved </span>
            <span>{{getSocre}}</span>/{{totalNum}} ({{correctPercent}})-->
            <span>Thank you for completing this knowledge assessment!</span><br/>
            <span>Please allow up to three business days while we review your application.</span>
            <br>
            <el-button class="yellowBtn" style="margin-top: 10px;" @click="goPre">Back</el-button>
        </div>
        <el-form v-show="!pdfLoading" :model="form" ref="form" :rules="rules" v-if="!showResult&&hasFinished">
            <div class="smallBox" style="min-height: 600px">
                <div class="viewPDF" >
                    <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&!isCorrectSub1"></el-image>
                    <span>EOB #1 <u @click="openPdf(1)">View PDF</u></span>
                </div>
                <el-form-item prop="sub0">
                    <div class="titleInner"><el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub0!='2'"></el-image>
                        How many payments were made by MetLife for this DOS?</div>
                    <el-input class="select" style="width: 30%" v-model="form.sub0" ref="sub0" :disabled="isAdmin"
                              oninput="this.value=(this.value.replace(/[^0-9]+/,'')).slice(0,11);"></el-input>
                    <div class="key" v-if="isAdmin&&form.sub0!=2">
                        2
                    </div>
                </el-form-item>
                <el-form-item prop="sub1" class="mt40" ref="sub1">
                    <div class="titleInner"><el-image :src="wrong" style="width: 20px" v-if="isAdmin&&!(form.sub1.a&&form.sub1.b&&!form.sub1.c&&!form.sub1.d)"></el-image>
                        What kind of a payment was made?</div>
                    <div class="select">
                        <el-checkbox v-model="form.sub1.a" :disabled="isAdmin">EFT (direct deposit)</el-checkbox><br>
                        <el-checkbox v-model="form.sub1.b" :disabled="isAdmin">Check</el-checkbox><br>
                        <el-checkbox v-model="form.sub1.c" :disabled="isAdmin">Credit</el-checkbox><br>
                        <el-checkbox v-model="form.sub1.d" :disabled="isAdmin">Other</el-checkbox>
                    </div>
                    <div class="key" v-if="isAdmin&&!(form.sub1.a&&form.sub1.b&&!form.sub1.c&&!form.sub1.d)">
                        EFT (direct deposit)
                    </div>
                    <div class="key mt30" v-if="isAdmin&&!(form.sub1.a&&form.sub1.b&&!form.sub1.c&&!form.sub1.d)">
                        Check
                    </div>
                </el-form-item>

                <el-form-item prop="sub2" class="mt90">
                    <div class="titleInner">Details?</div>
                    <el-input type="textarea" class="textarea" ref="sub2" v-model="form.sub2" :readonly="isAdmin"></el-input>
                </el-form-item>

                <el-form-item prop="sub3" class="mt60">
                    <div class="titleInner"><el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub3!='6/13/2012'"></el-image>
                        When was payment made?</div>
                    <el-date-picker
                            :disabled="isAdmin"
                            class="select"
                            ref="sub3"
                            v-model="form.sub3"
                            type="date"
                            placeholder=""
                            format="M/d/yyyy"
                            value-format="M/d/yyyy"
                            >
                    </el-date-picker>
<!--                    <el-input class="select" v-model="form.sub3" style="width: 30%" ref="sub3" :readonly="isAdmin"></el-input>-->
                    <div class="key" v-if="isAdmin&&form.sub3!='6/13/2012'">
                        6/13/2012
                    </div>
                </el-form-item>

                <el-form-item prop="sub4" class="mt40">
                    <div class="titleInner"><el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub4!=0"></el-image>
                        Was there a payment adjustment due to an alternate benefit?</div>
                    <div class="titleInner">
                        <el-select ref="sub4" v-model="form.sub4" placeholder="" class="select" :disabled="isAdmin">
                            <el-option label="Yes" :value="1"></el-option>
                            <el-option label="No" :value="0"></el-option>
                        </el-select>
                    </div>
                    <div class="key" v-if="isAdmin&&form.sub4!=0">
                        No
                    </div>
                </el-form-item>

                <el-form-item prop="sub5" class="mt30">
                    <div class="titleInner">If so, what was the alternate benefit given?</div>
                    <el-input type="textarea" class="textarea" ref="sub5" v-model="form.sub5" :readonly="isAdmin"></el-input>
                </el-form-item>

                <el-form-item prop="sub6" class="mt70">
                    <div class="titleInner"><el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub6!='48'"></el-image>
                        What was the allowed amount for services provide?</div>
                    <el-input class="select" style="width: 30%" ref="sub6" :readonly="isAdmin" v-model="form.sub6"
                              oninput="this.value=(this.value.replace(/[^0-9.]+/,'')).slice(0,11);"></el-input>
                    <div class="key" v-if="isAdmin&&form.sub6!='48'">
                        48
                    </div>
                </el-form-item>

                <el-form-item prop="sub7" class="mt40">
                    <div class="titleInner"><el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub7!=1"></el-image>
                        Is there a contractual adjustment?</div>
                    <div class="titleInner">
                        <el-select ref="sub7" v-model="form.sub7" placeholder="" class="select" :disabled="isAdmin">
                            <el-option label="Yes" :value="1"></el-option>
                            <el-option label="No" :value="0"></el-option>
                        </el-select>
                    </div>
                    <div class="key" v-if="isAdmin&&form.sub7!=1">
                        Yes
                    </div>
                </el-form-item>
            </div>

            <div class="smallBox" style="min-height: 500px">
                <div class="viewPDF">
                    <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&!isCorrectSub2"></el-image>
                    <span>EOB #2 <u @click="openPdf(2)">View PDF</u></span>
                </div>
                <el-form-item prop="sub8">
                    <div class="titleInner"><el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub8!='73'"></el-image>
                        What was the allowed amount for services provided?</div>
                    <el-input ref="sub8" class="select" style="width: 30%" v-model="form.sub8" :readonly="isAdmin"
                              oninput="this.value=(this.value.replace(/[^0-9.]+/,'')).slice(0,11);"></el-input>
                    <div class="key" v-if="isAdmin&&form.sub8!='73'">
                        73
                    </div>
                </el-form-item>

                <el-form-item prop="sub9" class="mt30">
                    <div class="titleInner"><el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub9!='0'"></el-image>
                        How much did MetLife pay?</div>
                    <el-input class="select" ref="sub9" style="width: 30%" v-model="form.sub9" :readonly="isAdmin"
                              oninput="this.value=(this.value.replace(/[^0-9.]+/,'')).slice(0,11);"></el-input>
                    <div class="key" v-if="isAdmin&&form.sub9!='0'">
                        0
                    </div>
                </el-form-item>
                <el-form-item prop="sub10" class="mt30" ref="sub10">
                    <p class="titleInner">
                        <el-image :src="wrong" style="width: 20px"
                                  v-if="isAdmin&&!(!form.sub10.a&&!form.sub10.b&&!form.sub10.c&&form.sub10.d)"></el-image>
                        What kind of a payment was it?</p>
                    <div class="select">
                        <el-checkbox v-model="form.sub10.a" :disabled="isAdmin">EFT (direct deposit)</el-checkbox><br>
                        <el-checkbox v-model="form.sub10.b" :disabled="isAdmin">Check</el-checkbox><br>
                        <el-checkbox v-model="form.sub10.c" :disabled="isAdmin">Credit</el-checkbox><br>
                        <el-checkbox v-model="form.sub10.d" :disabled="isAdmin">Other</el-checkbox>
                    </div>
                    <div class="key" v-if="isAdmin&&!(!form.sub10.a&&!form.sub10.b&&!form.sub10.c&&form.sub10.d)">
                        Other
                    </div>
                </el-form-item>

                <el-form-item prop="sub11" class="mt90">
                    <div class="titleInner">Details?</div>
                    <el-input ref="sub11" type="textarea" class="textarea" v-model="form.sub11" :readonly="isAdmin"></el-input>
                </el-form-item>

                <el-form-item prop="sub12" class="mt60">
                    <div class="titleInner"><el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub12!=0"></el-image>
                        How would you find the answer to the how payment was made?</div>
                    <div class="titleInner">
                        <el-select ref="sub12" v-model="form.sub12" placeholder="" class="select longSelect" :disabled="isAdmin" >
                            <el-option label="Call Metlife" :value="0"></el-option>
                            <el-option label="Patient Charts" :value="1"></el-option>
                            <el-option label="Medical History" :value="2"></el-option>
                            <el-option label="Call Patient" :value="3"></el-option>
                        </el-select>
                    </div>
                    <div class="key" v-if="isAdmin&&form.sub12!=0">
                        Call Metlife
                    </div>
                </el-form-item>

                <el-form-item prop="sub13" class="mt30">
                    <div class="titleInner">How would you apply this to the patient ledger?</div>
                    <el-input ref="sub13" type="textarea" class="textarea" v-model="form.sub13" :readonly="isAdmin"></el-input>
                </el-form-item>
            </div>

            <div class="smallBox" style="min-height: 500px">
                <div class="viewPDF">
                    <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&isCorrectSub3"></el-image>
                    <span>EOB #3 <u @click="openPdf(3)">View PDF</u></span>
                </div>
                <el-form-item prop="sub14">
                    <div class="titleInner"><el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub14!='84'"></el-image>
                        What was the allowed amount for services provided?</div>
                    <el-input class="select" style="width: 30%" ref="sub14" v-model="form.sub14" :readonly="isAdmin"
                              oninput="this.value=(this.value.replace(/[^0-9.]+/,'')).slice(0,11);"></el-input>
                    <div class="key" v-if="isAdmin&&form.sub14!=84">
                        84
                    </div>
                </el-form-item>
                <el-form-item prop="sub15" class="mt30" ref="sub15">
                    <p class="titleInner"><el-image :src="wrong" style="width: 20px" v-if="isAdmin&&!(form.sub15.a&&!form.sub15.b&&!form.sub15.c&&!form.sub15.d)"></el-image>
                        What kind of a payment was it?</p>
                    <div class="select">
                        <el-checkbox v-model="form.sub15.a" :disabled="isAdmin">EFT (direct deposit)</el-checkbox><br>
                        <el-checkbox v-model="form.sub15.b" :disabled="isAdmin">Check</el-checkbox><br>
                        <el-checkbox v-model="form.sub15.c" :disabled="isAdmin">Credit</el-checkbox><br>
                        <el-checkbox v-model="form.sub15.d" :disabled="isAdmin">Other</el-checkbox>
                    </div>
                    <div class="key" v-if="isAdmin&&!(form.sub15.a&&!form.sub15.b&&!form.sub15.c&&!form.sub15.d)">
                        EFT (direct deposit)
                    </div>
                </el-form-item>
                <el-form-item prop="sub16" class="mt90">
                    <p class="titleInner">Details?</p>
                    <el-input ref="sub16" class="textarea" type="textarea" v-model="form.sub16" :disabled="isAdmin"></el-input>
                </el-form-item>

                <el-form-item prop="sub17" class="mt60">
                    <div class="titleInner"><el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub17!=1"></el-image>
                        Was an alternate benefit applied?</div>
                    <div class="titleInner">
                        <el-select ref="sub17" v-model="form.sub17" placeholder="" class="select" :disabled="isAdmin">
                            <el-option label="Yes" :value="1"></el-option>
                            <el-option label="No" :value="0"></el-option>
                        </el-select>
                    </div>
                    <div class="key" v-if="isAdmin&&form.sub17!=1">
                        Yes
                    </div>
                </el-form-item>

                <el-form-item prop="sub18" class="mt20">
                    <p class="titleInner">If so, what was the alternate benefit given?</p>
                    <el-input ref="sub18" class="textarea" type="textarea" v-model="form.sub18" :disabled="isAdmin"></el-input>
                </el-form-item>

                <el-form-item prop="sub19" class="mt60">
                    <div class="titleInner"><el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub19!=0"></el-image>
                        Does the patient owe a balance?</div>
                    <div class="titleInner">
                        <el-select ref="sub19" v-model="form.sub19" placeholder="" class="select" :disabled="isAdmin">
                            <el-option label="Yes" :value="1"></el-option>
                            <el-option label="No" :value="0"></el-option>
                        </el-select>
                    </div>
                    <div class="key" v-if="isAdmin&&form.sub19!=0">
                        No
                    </div>
                </el-form-item>

                <el-form-item prop="sub20" class="mt20">
                    <div class="titleInner"><el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub20!=1"></el-image>
                        Is there a contractual adjustment?</div>
                    <div class="titleInner">
                        <el-select ref="sub20" v-model="form.sub20" placeholder="" class="select" :disabled="isAdmin">
                            <el-option label="Yes" :value="1"></el-option>
                            <el-option label="No" :value="0"></el-option>
                        </el-select>
                    </div>
                    <div class="key" v-if="isAdmin&&form.sub20!=1">
                        Yes
                    </div>
                </el-form-item>
            </div>

            <div class="smallBox" style="min-height: 550px">
                <div class="viewPDF">
                    <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&!isCorrectSub4"></el-image>
                    <span>EOB #4 <u @click="openPdf(4)">View PDF</u></span>
                </div>
                <el-form-item prop="sub21">
                    <div class="titleInner">
                        <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub21!='104'"></el-image>
                        What was the allowed amount for services?</div>
                    <el-input ref="sub21" class="select" style="width: 30%" v-model="form.sub21" :disabled="isAdmin"
                              oninput="this.value=(this.value.replace(/[^0-9.]+/,'')).slice(0,11);"></el-input>
                    <div class="key" v-if="isAdmin&&form.sub21!='104'">
                        104
                    </div>
                </el-form-item>
                <el-form-item prop="sub22" class="mt30" ref="sub22">
                    <p class="titleInner">
                        <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&!(form.sub22.a&&!form.sub22.b&&!form.sub22.c&&!form.sub22.d)"></el-image>
                        What kind of a payment was it?</p>
                    <div class="select">
                        <el-checkbox v-model="form.sub22.a" :disabled="isAdmin">EFT (direct deposit)</el-checkbox><br>
                        <el-checkbox v-model="form.sub22.b" :disabled="isAdmin">Check</el-checkbox><br>
                        <el-checkbox v-model="form.sub22.c" :disabled="isAdmin">Credit</el-checkbox><br>
                        <el-checkbox v-model="form.sub22.d" :disabled="isAdmin">Other</el-checkbox>
                    </div>
                    <div class="key" v-if="isAdmin&&!(form.sub22.a&&!form.sub22.b&&!form.sub22.c&&!form.sub22.d)">
                        EFT (direct deposit)
                    </div>
                </el-form-item>

                <el-form-item prop="sub23"  class="mt90">
                    <div class="titleInner">
                        <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub23!='163'"></el-image>
                        Billed Amount?</div>
                    <el-input ref="sub23" class="select" style="width: 30%" :disabled="isAdmin" v-model="form.sub23"
                              oninput="this.value=(this.value.replace(/[^0-9.]+/,'')).slice(0,11);"></el-input>
                    <div class="key" v-if="isAdmin&&form.sub23!='163'">
                        163
                    </div>
                </el-form-item>
                <el-form-item prop="sub24" class="mt30">
                    <div class="titleInner"> <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub24!='104'"></el-image>
                        Allowable Amount?</div>
                    <el-input ref="sub24" class="select" style="width: 30%" v-model="form.sub24" :disabled="isAdmin"
                              oninput="this.value=(this.value.replace(/[^0-9.]+/,'')).slice(0,11);"></el-input>
                    <div class="key" v-if="isAdmin&&form.sub24!='104'">
                        104
                    </div>
                </el-form-item>
                <el-form-item prop="sub25" class="mt30">
                    <div class="titleInner">
                        <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub25!='59'"></el-image>
                        Contract Adjustment Based on Fee Charged?</div>
                    <el-input ref="sub25" class="select" style="width: 30%" v-model="form.sub25" :disabled="isAdmin"
                              oninput="this.value=(this.value.replace(/[^0-9.]+/,'')).slice(0,11);"></el-input>
                    <div class="key" v-if="isAdmin&&form.sub25!='59'">
                        59
                    </div>
                </el-form-item>

                <el-form-item prop="answer0" class="mt30">
                    <div class="titleInner">
                        <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub26!=1"></el-image>
                        Does the patient owe a balance?</div>
                    <div class="titleInner">
                        <el-select ref="sub26" v-model="form.sub26" placeholder="" class="select" :disabled="isAdmin">
                            <el-option label="Yes" :value="1"></el-option>
                            <el-option label="No" :value="0"></el-option>
                        </el-select>
                    </div>
                    <div class="key" v-if="isAdmin&&form.sub26!=1">
                        Yes
                    </div>
                </el-form-item>
                <el-form-item prop="sub27" class="mt10">
                    <div class="titleInner">
                        <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub27!=1"></el-image>
                        Was an alternate benefit given?</div>
                    <div class="titleInner">
                        <el-select ref="sub27" v-model="form.sub27" placeholder="" class="select" :disabled="isAdmin">
                            <el-option label="Yes" :value="1"></el-option>
                            <el-option label="No" :value="0"></el-option>
                        </el-select>
                    </div>
                    <div class="key" v-if="isAdmin&&form.sub27!=1">
                        Yes
                    </div>
                </el-form-item>

                <el-form-item prop="sub28">
                    <div class="titleInner">If so, what was the alternate benefit given?</div>
                    <el-input ref="sub28" v-model="form.sub28" class="textarea" type="textarea" :disabled="isAdmin"></el-input>
                </el-form-item>

            </div>

            <div class="smallBox" style="min-height: 260px">
                <div class="viewPDF">
                    <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&!isCorrectSub5"></el-image>
                    <span>EOB #5 <u @click="openPdf(5)">View PDF</u></span>
                </div>
                <div>Question pertain to Joel Duran:</div>
                <el-form-item prop="sub29">
                    <div class="titleInner">
                        <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub29!='589'"></el-image>
                        What was the allowed amount for services provided?</div>
                    <el-input ref="sub29" v-model="form.sub29" class="select" style="width: 30%;" :disabled="isAdmin"
                              oninput="this.value=(this.value.replace(/[^0-9.]+/,'')).slice(0,11);"></el-input>
                    <div class="key" v-if="isAdmin&&form.sub29!='589'">
                        589
                    </div>
                </el-form-item>

                <el-form-item prop="sub30" class="mt30">
                    <div class="titleInner"><el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub30!='90115012801'"></el-image>
                        What is the members ID#?</div>
                    <el-input ref="sub30" v-model="form.sub30" class="select" style="width: 30%;" :disabled="isAdmin"
                              oninput="this.value=(this.value.replace(/[^0-9]+/,'')).slice(0,11);"></el-input>
                    <div class="key" v-if="isAdmin&&form.sub30!='90115012801'">
                        90115012801
                    </div>
                </el-form-item>

                <el-form-item prop="answer0" class="mt30">
                    <div class="titleInner">
                        <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub31!=1"></el-image>
                        Does the patient owe a balance?</div>
                    <div class="titleInner">
                        <el-select ref="sub31" v-model="form.sub31" placeholder="" class="select" :disabled="isAdmin">
                            <el-option label="Yes" :value="1"></el-option>
                            <el-option label="No" :value="0"></el-option>
                        </el-select>
                    </div>
                    <div class="key" v-if="isAdmin&&form.sub30!=1">
                        Yes
                    </div>
                </el-form-item>

                <el-form-item prop="sub32" class="mt10">
                    <p class="titleInner">
                        <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub32!='244'"></el-image>
                        If so, how much?</p>
                    <el-input ref="sub32" v-model="form.sub32" class="select" style="width: 30%;" :disabled="isAdmin"
                              oninput="this.value=(this.value.replace(/[^0-9.]+/,'')).slice(0,11);"></el-input>
                    <div class="key" v-if="isAdmin&&form.sub32!='244'">
                        244
                    </div>
                </el-form-item>
            </div>

            <div class="smallBox" style="min-height: 550px">
                <div class="viewPDF">
                    <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&!isCorrectSub6"></el-image>
                    <span>EOB #6 <u @click="openPdf(6)">View PDF</u></span>
                </div>

                <el-form-item prop="sub33">
                    <div class="titleInner">
                        <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&!(form.sub33.toLowerCase().indexOf('david')>=0&&form.sub33.toLowerCase().indexOf('tibbitts')>=0)"></el-image>
                        Who was the patient?</div>
                    <el-input ref="sub33" v-model="form.sub33" class="select" style="width: 30%;" :disabled="isAdmin"></el-input>
                    <div class="key" v-if="isAdmin&&!(form.sub33.toLowerCase().indexOf('david')>=0&&form.sub33.toLowerCase().indexOf('tibbitts')>=0)">
                        David Tibbitts
                    </div>
                </el-form-item>

                <el-form-item prop="sub34" class="mt30">
                    <div class="titleInner">
                        <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub34!='3/30/2012'"></el-image>
                        What is the date of service?</div>
                    <el-date-picker
                            :disabled="isAdmin"
                            class="select"
                            ref="sub34"
                            v-model="form.sub34"
                            type="date"
                            placeholder=""
                            format="M/d/yyyy"
                            value-format="M/d/yyyy"
                    >
                    </el-date-picker>
<!--                    <el-input ref="sub34" v-model="form.sub34" class="select" style="width: 30%;" :disabled="isAdmin"></el-input>-->
                    <div class="key" v-if="isAdmin&&form.sub33!='3/30/2012'">
                        3/30/2012
                    </div>
                </el-form-item>

                <el-form-item prop="sub35" class="mt30">
                    <div class="titleInner">
                        <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub35!=1"></el-image>
                        Is there a contractual adjustment?</div>
                    <div class="titleInner">
                        <el-select ref="sub35" v-model="form.sub35" placeholder="" class="select" :disabled="isAdmin">
                            <el-option label="Yes" :value="1"></el-option>
                            <el-option label="No" :value="0"></el-option>
                        </el-select>
                    </div>
                    <div class="key" v-if="isAdmin&&form.sub35!=1">
                        Yes
                    </div>
                </el-form-item>

                <el-form-item prop="sub36" class="mt10">
                    <div class="titleInner">
                        <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub36!=1"></el-image>
                        Does the patient owe a balance?</div>
                    <div class="titleInner">
                        <el-select ref="sub36" v-model="form.sub36" placeholder="" class="select" :disabled="isAdmin">
                            <el-option label="Yes" :value="1"></el-option>
                            <el-option label="No" :value="0"></el-option>
                        </el-select>
                    </div>
                    <div class="key" v-if="isAdmin&&form.sub36!=1">
                        Yes
                    </div>
                </el-form-item>

                <el-form-item prop="sub37">
                    <div class="titleInner">
                        <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub37!='360.5'"></el-image>
                        If so, how much?</div>
                    <el-input ref="sub37" v-model="form.sub37" class="select" style="width: 30%;" :disabled="isAdmin"
                              oninput="this.value=(this.value.replace(/[^0-9.]+/,'')).slice(0,11);"></el-input>
                    <div class="key" v-if="isAdmin&&form.sub37!='360.5'">
                        360.5
                    </div>
                </el-form-item>

                <el-form-item prop="sub38" class="mt30">
                    <div class="titleInner">
                        <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub38!=1"></el-image>
                        Was a deductible taken?</div>
                    <div class="titleInner">
                        <el-select ref="sub38" v-model="form.sub38" placeholder="" class="select" :disabled="isAdmin">
                            <el-option label="Yes" :value="1"></el-option>
                            <el-option label="No" :value="0"></el-option>
                        </el-select>
                    </div>
                    <div class="key" v-if="isAdmin&&form.sub38!=1">
                        Yes
                    </div>
                </el-form-item>

                <el-form-item prop="sub39" class="mt10">
                    <div class="titleInner">
                        <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub39!=0"></el-image>
                        Was the sealant a covered benefit?</div>
                    <div class="titleInner">
                        <el-select ref="sub39" v-model="form.sub39" placeholder="" class="select" :disabled="isAdmin">
                            <el-option label="Yes" :value="1"></el-option>
                            <el-option label="No" :value="0"></el-option>
                        </el-select>
                    </div>
                    <div class="key" v-if="isAdmin&&form.sub39!=0">
                        No
                    </div>
                </el-form-item>
                <el-form-item prop="sub40" class="mt10">
                    <p class="titleInner">If not,why not?</p>
                    <el-input ref="sub40" v-model="form.sub40" class="textarea" type="textarea" :disabled="isAdmin"></el-input>
                </el-form-item>

                <el-form-item prop="sub41" class="mt60">
                    <p class="titleInner">
                        <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub41!='16'"></el-image>
                        Through what age are sealants covered?</p>
                    <el-input ref="sub41" v-model="form.sub41" class="select" style="width: 30%" :disabled="isAdmin"
                              oninput="this.value=(this.value.replace(/[^0-9]+/,'')).slice(0,11);"></el-input>
                    <div class="key" v-if="isAdmin&&form.sub41!='16'">
                        16
                    </div>
                </el-form-item>
            </div>

            <div class="smallBox" style="min-height: 450px">
                <div class="viewPDF">
                <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&!isCorrectSub7"></el-image>
                <span>EOB #7 <u @click="openPdf(7)">View PDF</u></span>
            </div>
                <div>Questions pertain to Valerie Walker:</div>
                <el-form-item prop="sub42">
                    <div class="titleInner">
                        <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub42!='230'"></el-image>
                        What was the allowed amount for services provided?</div>
                    <el-input ref="sub42" v-model="form.sub42" class="select" style="width: 30%" :disabled="isAdmin"
                              oninput="this.value=(this.value.replace(/[^0-9.]+/,'')).slice(0,11);"></el-input>
                    <div class="key" v-if="isAdmin&&form.sub42!='230'">
                        230
                    </div>
                </el-form-item>
                <el-form-item prop="sub43" class="mt30">
                    <div class="titleInner">
                        <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub43!=1"></el-image>
                        Was there a deductible?</div>
                    <div class="titleInner">
                        <el-select ref="sub43" v-model="form.sub43" placeholder="" class="select" :disabled="isAdmin">
                            <el-option label="Yes" :value="1"></el-option>
                            <el-option label="No" :value="0"></el-option>
                        </el-select>
                    </div>
                    <div class="key" v-if="isAdmin&&form.sub43!=1">
                        Yes
                    </div>
                </el-form-item>

                <el-form-item prop="sub44" class="mt10">
                    <p class="titleInner">
                        <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub44!='20'"></el-image>
                        If so, how much?</p>
                    <el-input ref="sub44" v-model="form.sub44" class="select" style="width: 30%" :disabled="isAdmin"
                              oninput="this.value=(this.value.replace(/[^0-9.]+/,'')).slice(0,11);"></el-input>
                    <div class="key" v-if="isAdmin&&form.sub44!='20'">
                        20
                    </div>
                </el-form-item>

                <el-form-item prop="sub45" class="mt30">
                    <p class="titleInner">
                        <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub45!=1"></el-image>
                        Does the patient owe a balance?</p>
                    <div class="titleInner">
                        <el-select ref="sub45" v-model="form.sub45" placeholder="" class="select" :disabled="isAdmin">
                            <el-option label="Yes" :value="1"></el-option>
                            <el-option label="No" :value="0"></el-option>
                        </el-select>
                    </div>
                    <div class="key" v-if="isAdmin&&form.sub45!=1">
                        Yes
                    </div>
                </el-form-item>
                <el-form-item prop="sub46" class="mt10">
                    <p class="titleInner">
                        <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub46!='125'"></el-image>
                        If so, how much?</p>
                    <el-input ref="sub46" v-model="form.sub46" class="select" style="width: 30%" :disabled="isAdmin"
                              oninput="this.value=(this.value.replace(/[^0-9.]+/,'')).slice(0,11);"></el-input>
                    <div class="key" v-if="isAdmin&&form.sub46!='125'">
                        125
                    </div>
                </el-form-item>
                <el-form-item prop="sub47" class="mt30">
                    <p class="titleInner">
                        <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub47!=1"></el-image>
                        Is there contractual adjustment?</p>
                    <div class="titleInner">
                        <el-select ref="sub47" v-model="form.sub47" placeholder="" class="select" :disabled="isAdmin">
                            <el-option label="Yes" :value="1"></el-option>
                            <el-option label="No" :value="0"></el-option>
                        </el-select>
                    </div>
                    <div class="key" v-if="isAdmin&&form.sub47!=1">
                        Yes
                    </div>
                </el-form-item>
                <el-form-item prop="sub48">
                    <p class="titleInner">
                        <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub48!='26'"></el-image>
                        If so, how much?</p>
                    <el-input ref="sub48" v-model="form.sub48" class="select" style="width: 30%" :disabled="isAdmin"
                              oninput="this.value=(this.value.replace(/[^0-9.]+/,'')).slice(0,11);"></el-input>
                    <div class="key" v-if="isAdmin&&form.sub48!='26'">
                        26
                    </div>
                </el-form-item>
            </div>

            <div class="smallBox" style="min-height: 300px">
                <div class="viewPDF">
                    <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&!isCorrectSub8"></el-image>
                    <span>EOB #8 <u @click="openPdf(8)">View PDF</u></span>
                </div>
                <el-form-item prop="sub49">
                    <div class="titleInner">
                        <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub49!='526'"></el-image>
                        What was the allowed amount for services provided?</div>
                    <el-input ref="sub49" v-model="form.sub49" class="select" style="width: 30%" :disabled="isAdmin"
                              oninput="this.value=(this.value.replace(/[^0-9.]+/,'')).slice(0,11);"></el-input>
                    <div class="key" v-if="isAdmin&&form.sub49!='526'">
                        526
                    </div>
                </el-form-item>
                <el-form-item prop="sub50" class="mt30">
                    <div class="titleInner">
                        <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub50!='0'"></el-image>
                        How much does the patient owe?</div>
                    <el-input ref="sub50" v-model="form.sub50" class="select" style="width: 30%" :disabled="isAdmin"
                              oninput="this.value=(this.value.replace(/[^0-9.]+/,'')).slice(0,11);"></el-input>
                    <div class="key" v-if="isAdmin&&form.sub50!='0'">
                        0
                    </div>
                </el-form-item>

                <el-form-item prop="sub51" class="mt30">
                    <div class="titleInner">
                        <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub51!=1"></el-image>
                        Is there contractual adjustment?</div>
                    <div class="titleInner">
                        <el-select ref="sub51" v-model="form.sub51" placeholder="" class="select" :disabled="isAdmin">
                            <el-option label="Yes" :value="1"></el-option>
                            <el-option label="No" :value="0"></el-option>
                        </el-select>
                    </div>
                    <div class="key" v-if="isAdmin&&form.sub51!=1">
                        Yes
                    </div>
                </el-form-item>

                <el-form-item prop="sub52" class="mt10">
                    <p class="titleInner">
                        <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub52!='324'"></el-image>
                        If so, how much?</p>
                    <el-input ref="sub52" v-model="form.sub52" class="select" style="width: 30%" :disabled="isAdmin"
                              oninput="this.value=(this.value.replace(/[^0-9.]+/,'')).slice(0,11);"></el-input>
                    <div class="key" v-if="isAdmin&&form.sub52!='324'">
                        324
                    </div>
                </el-form-item>

                <el-form-item prop="sub53" class="mt30">
                    <p class="titleInner">
                        <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub53!=0"></el-image>
                        Was there a deductible?</p>
                    <div class="titleInner">
                        <el-select ref="sub53" v-model="form.sub53" placeholder="" class="select" :disabled="isAdmin">
                            <el-option label="Yes" :value="1"></el-option>
                            <el-option label="No" :value="0"></el-option>
                        </el-select>
                    </div>
                    <div class="key" v-if="isAdmin&&form.sub53!=0">
                        No
                    </div>
                </el-form-item>

            </div>

            <div class="smallBox" style="min-height: 400px">
                <div class="viewPDF">
                    <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&!isCorrectSub9"></el-image>
                    <span>EOB #9 <u @click="openPdf(9)">View PDF</u></span>
                </div>
                <el-form-item prop="sub54">
                    <div class="titleInner">
                        <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub54!='1724'"></el-image>
                        What is the total amount submitted for services?
                    </div>
                    <el-input ref="sub54" v-model="form.sub54" class="select" style="width: 30%" :disabled="isAdmin"
                              oninput="this.value=(this.value.replace(/[^0-9.]+/,'')).slice(0,11);"></el-input>
                    <div class="key" v-if="isAdmin&&form.sub54!='1724'">
                        1724
                    </div>

                </el-form-item>

                <el-form-item prop="sub55" class="mt30">
                    <div class="titleInner">
                        <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub55!=0"></el-image>
                        Was there a deductible?</div>
                    <div class="titleInner">
                        <el-select ref="sub55" v-model="form.sub55" placeholder="" class="select" :disabled="isAdmin">
                            <el-option label="Yes" :value="1"></el-option>
                            <el-option label="No" :value="0"></el-option>
                        </el-select>
                    </div>
                    <div class="key" v-if="isAdmin&&form.sub55!=0">
                        No
                    </div>
                </el-form-item>

                <el-form-item prop="sub56" class="mt10">
                    <p class="titleInner">
                        <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub56!='0'"></el-image>
                        If so, how much?</p>
                    <el-input ref="sub56" v-model="form.sub56" class="select" style="width: 30%" :disabled="isAdmin"
                              oninput="this.value=(this.value.replace(/[^0-9.]+/,'')).slice(0,11);"></el-input>
                    <div class="key" v-if="isAdmin&&form.sub56!='0'">
                        0
                    </div>
                </el-form-item>

                <el-form-item prop="sub57" class="mt30">
                    <p class="titleInner">
                        <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub57!='1208'"></el-image>
                        What was the allowed amount for services provided?</p>
                    <el-input ref="sub57" v-model="form.sub57" class="select" style="width: 30%" :disabled="isAdmin"
                              oninput="this.value=(this.value.replace(/[^0-9.]+/,'')).slice(0,11);"></el-input>
                    <div class="key" v-if="isAdmin&&form.sub57!='1208'">
                        1208
                    </div>
                </el-form-item>

                <el-form-item prop="sub58" class="mt30">
                    <div class="titleInner">
                        <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub58!=1"></el-image>
                        Does the patient owe a balance?</div>
                    <div class="titleInner">
                        <el-select ref="sub58" v-model="form.sub58" placeholder="" class="select" :disabled="isAdmin">
                            <el-option label="Yes" :value="1"></el-option>
                            <el-option label="No" :value="0"></el-option>
                        </el-select>
                    </div>
                    <div class="key" v-if="isAdmin&&form.sub58!=1">
                        Yes
                    </div>
                </el-form-item>

                <el-form-item prop="sub59" class="mt10">
                    <div class="titleInner">
                        <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub59!=1"></el-image>
                        Is there contractual adjustment?</div>
                    <div class="titleInner">
                        <el-select ref="sub59" v-model="form.sub59" placeholder="" class="select" :disabled="isAdmin">
                            <el-option label="Yes" :value="1"></el-option>
                            <el-option label="No" :value="0"></el-option>
                        </el-select>
                    </div>
                    <div class="key" v-if="isAdmin&&form.sub59!=1">
                        Yes
                    </div>
                </el-form-item>
                <el-form-item prop="sub60" class="mt10">
                    <p class="titleInner">
                        <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub60!='526'"></el-image>
                        If so, how much?</p>
                    <el-input ref="sub60" v-model="form.sub60" class="select" style="width: 30%" :disabled="isAdmin"
                              oninput="this.value=(this.value.replace(/[^0-9.]+/,'')).slice(0,11);"></el-input>
                    <div class="key" v-if="isAdmin&&form.sub60!='526'">
                        526
                    </div>
                </el-form-item>
            </div>

            <div class="smallBox" style="min-height: 520px">
                <div class="viewPDF">
                    <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&!isCorrectSub10"></el-image>
                    <span>EOB #10 <u @click="openPdf(10)">View PDF</u></span>
                </div>
                <el-form-item prop="sub61">
                    <div class="titleInner">
                        <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&!(form.sub61=='Saralynn Hansen'||form.sub61=='Christal Stephens')"></el-image>
                        What patient will you use to answer the next questions;Saralynn Hansen or Christal Stephens?</div>
                    <el-input ref="sub61" v-model="form.sub61" class="select" style="width: 25%" :disabled="isAdmin"></el-input>
                    <div class="key1"
                         v-if="isAdmin&&!(form.sub61=='Saralynn Hansen'||form.sub61=='Christal Stephens')">
                        Saralynn Hansen
                    </div>
                    <span class="between" v-if="isAdmin&&!(form.sub61=='Saralynn Hansen'||form.sub61=='Christal Stephens')">/</span>
                    <div class="key2"
                         v-if="isAdmin&&!(form.sub61=='Saralynn Hansen'||form.sub61=='Christal Stephens')">
                        Christal Stephens
                    </div>
                </el-form-item>

                <el-form-item prop="sub62" class="mt10">
                    <div class="titleInner">
                        <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&!(form.sub61=='Saralynn Hansen'&&form.sub62=='613'||form.sub61=='Christal Stephens'&&form.sub62=='520')"></el-image>
                        What was the allowed amount for services provided?</div>
                    <el-input ref="sub62" v-model="form.sub62" class="select" style="width: 25%" :disabled="isAdmin"
                              oninput="this.value=(this.value.replace(/[^0-9.]+/,'')).slice(0,11);"></el-input>
                    <div class="key1" v-if="isAdmin&&!((form.sub61=='Saralynn Hansen'&&form.sub62=='613')||(form.sub61=='Christal Stephens'&&form.sub62=='520'))">
                        613
                    </div>
                    <span class="between" v-if="isAdmin&&!(form.sub61=='Saralynn Hansen'&&form.sub62=='613'||form.sub61=='Christal Stephens'&&form.sub62=='520')">/</span>
                    <div class="key2"
                         v-if="isAdmin&&!(form.sub61=='Saralynn Hansen'&&form.sub62=='613'||form.sub61=='Christal Stephens'&&form.sub62=='520')">
                        520
                    </div>
                </el-form-item>

                <el-form-item prop="sub63" class="mt30">
                    <p class="titleInner">
                        <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub63!=1"></el-image>
                        Does the patient owe a balance?</p>
                    <div class="titleInner">
                        <el-select ref="sub63" v-model="form.sub63" placeholder="" class="select" :disabled="isAdmin">
                            <el-option label="Yes" :value="1"></el-option>
                            <el-option label="No" :value="0"></el-option>
                        </el-select>
                    </div>
                    <div class="key1" v-if="isAdmin&&form.sub63!=1">
                        Yes
                    </div>
                    <span class="between" v-if="isAdmin&&form.sub63!=1">/</span>
                    <div class="key2" v-if="isAdmin&&form.sub63!=1">
                        Yes
                    </div>
                </el-form-item>

                <el-form-item prop="sub64" class="mt10">
                    <p class="titleInner">
                        <el-image :src="wrong" style="width: 20px"
                                  v-if="isAdmin&&!(form.sub61=='Saralynn Hansen'&&form.sub64=='138'||form.sub61=='Christal Stephens'&&form.sub64=='104')"></el-image>
                        If so, how much?</p>
                    <el-input ref="sub64" v-model="form.sub64" class="select" style="width: 25%" :disabled="isAdmin"
                              oninput="this.value=(this.value.replace(/[^0-9.]+/,'')).slice(0,11);"></el-input>
                    <div class="key1"
                         v-if="isAdmin&&!(form.sub61=='Saralynn Hansen'&&form.sub64=='138'||form.sub61=='Christal Stephens'&&form.sub64=='104')">
                        138
                    </div>
                    <span class="between"
                          v-if="isAdmin&&!(form.sub61=='Saralynn Hansen'&&form.sub64=='138'||form.sub61=='Christal Stephens'&&form.sub64=='104')">/</span>
                    <div class="key2"
                         v-if="isAdmin&&!(form.sub61=='Saralynn Hansen'&&form.sub64=='138'||form.sub61=='Christal Stephens'&&form.sub64=='104')">
                        104
                    </div>
                </el-form-item>

                <el-form-item prop="sub65" class="mt30">
                    <div class="titleInner">
                        <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub65!=0"></el-image>
                        Is there contractual adjustment?</div>
                    <div class="titleInner">
                        <el-select ref="sub65" v-model="form.sub65" placeholder="" class="select" :disabled="isAdmin">
                            <el-option label="Yes" :value="1"></el-option>
                            <el-option label="No" :value="0"></el-option>
                        </el-select>
                    </div>
                    <div class="key1"
                         v-if="isAdmin&&form.sub65!=0">
                        No
                    </div>
                    <span class="between"
                          v-if="isAdmin&&form.sub65!=0">/</span>
                    <div class="key2"
                         v-if="isAdmin&&form.sub65!=0">
                        No
                    </div>
                </el-form-item>

                <el-form-item prop="sub66" class="mt10">
                    <div class="titleInner">
                        <el-image :src="wrong" style="width: 20px"
                                  v-if="isAdmin&&!(form.sub61=='Saralynn Hansen'&&form.sub66==1||form.sub61=='Christal Stephens'&&form.sub66==0)"></el-image>
                        Do you need to contact insurance for any reason?</div>
                    <div class="titleInner">
                        <el-select ref="sub66" v-model="form.sub66" placeholder="" class="select" :disabled="isAdmin">
                            <el-option label="Yes" :value="1"></el-option>
                            <el-option label="No" :value="0"></el-option>
                        </el-select>
                    </div>
                    <div class="key1"
                         v-if="isAdmin&&!(form.sub61=='Saralynn Hansen'&&form.sub66==1||form.sub61=='Christal Stephens'&&form.sub66==0)">
                        Yes
                    </div>
                    <span class="between"
                          v-if="isAdmin&&!(form.sub61=='Saralynn Hansen'&&form.sub66==1||form.sub61=='Christal Stephens'&&form.sub66==0)">/</span>
                    <div class="key2"
                         v-if="isAdmin&&!(form.sub61=='Saralynn Hansen'&&form.sub66==1||form.sub61=='Christal Stephens'&&form.sub66==0)">
                        No
                    </div>
                </el-form-item>
                <el-form-item prop="sub67">
                    <p class="titleInner">If so, why?</p>
                    <el-input ref="sub67" v-model="form.sub67" class="textarea" type="textarea" :disabled="isAdmin"></el-input>
                </el-form-item>
            </div>

            <div style="margin-top:10px;margin-bottom: 20px">
                <el-button class="yellowBtn" @click="submitPrepare" v-if="!isAdmin">Submit</el-button>
                <el-button class="grayBtn" @click="cancel">Cancel</el-button>
                <span style="margin-left:10px" v-if="isAdmin">Exam Completed {{ forMateTime(finishDate,true) }}</span>
            </div>
        </el-form>
        <el-dialog :title="titleName" :visible.sync="pdfVisible" width="80%">
            <pdf :src="pdfSrc"></pdf>
            <span slot="footer">
                <el-button class="grayBtn" @click="pdfVisible=false">Close</el-button>
            </span>
        </el-dialog>

        <el-dialog title="Confirm" :visible.sync="exitVisible">
            <div>Are you sure you want to cancel the test?</div>
            <span slot="footer">
                <el-button class="yellowBtn" @click="goBack">Yes</el-button>
                <el-button class="grayBtn" @click="exitVisible=false">No</el-button>
            </span>
        </el-dialog>

        <el-dialog title="Confirm" :visible.sync="confirmVisible" width="50%">
            <div style="line-height: 25px;padding: 0 10px;word-wrap:break-word">Caution:this portion of our skills assessment test you are about to view cannot be saved for later. You will
                be scored with no option to return later if you proceed. Do you want to continue?</div>
            <span slot="footer">
                <el-button class="yellowBtn" @click="submit">Yes</el-button>
                <el-button class="grayBtn" @click="confirmVisible=false">No</el-button>
            </span>
        </el-dialog>

        <!-- 添加确认对话框 -->
        <el-dialog
            title="Assessment Complete"
            :visible.sync="completionDialogVisible"
            :show-close="false"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            width="50%">
            <div style="text-align: center">
                <p>Thank you for completing this knowledge assessment.</p>
                <p>Please allow up to three business days while we review your application.</p>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button class="yellowBtn" @click="handleCompletionConfirm">OK</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    //import pdfSrc from "../../assets/file/ClaimFormExam/Claim1.pdf"
    import wrong from "../../assets/pic/wrong.png"
    import right from "../../assets/pic/right.png"
    import pdf from 'vue-pdf'
    export default {
        name: "EOBExam",
        components:{pdf},
        data(){
            let validateEmptyFour= (rule, value, callback) => {
                // console.log('here')
                if (!value.a&&!value.b&&!value.c&&!value.d) {
                    callback(new Error('Required'))
                } else {
                    callback()
                }
            }
            return{
                finishDate:'',
                getSocre:0,
                /**用户53分测试数据**/
                // testData:[{'score':7,'possible':7,'detail':[2,'ab','dcsc','6/13/2012',0,'sasasdasda',48,1]},
                //     {'score':4,'possible':4,'detail':[73,0,'d','xwxw','Call Metlife','dwe']},
                //     {'score':4,'possible':5,'detail':[84,'a','sddasd',0,'ddwqwwqwq',0,1]},
                //     {'score':6,'possible':7,'detail':[104,'a',163,104,28,1,1,'xwdwewe']},
                //     {'score':3,'possible':4,'detail':[345,'90115012801',1,244]},
                //     {'score':6,'possible':8,'detail':['David O Tibbitts','3/30/2012',1,1,153.5,1,0,'adaads',17]},
                //     {'score':7,'possible':7,'detail':[230,1,20,1,125,1,26]},
                //     {'score':5,'possible':5,'detail':[526,0,1,324,0]},
                //     {'score':7,'possible':7,'detail':[1734,0,0,1208,1,1,526]},
                //     {'score':1,'possible':6,'detail':['Christal Stephens',520,0,0,0,0,'dsda']}],
                showResult:true,
                hasFinished:false,
                correctNum:0,
                totalNum:60,
                wrong:wrong,
                right:right,
                exitVisible:false,
                confirmVisible:false,
                pdfVisible:false,
                pdfLoading:false,
                pdfSrc:'',
                titleName:'',
                isAdmin:false,
                completionDialogVisible: false,
                form:{
                    sub1:{},
                    sub2:'',
                    sub3:'',
                    sub4:0,
                    sub5:'',
                    sub7:0,
                    sub10:{},
                    sub11:'',
                    sub12:0,
                    sub13:'',
                    sub15:{},
                    sub16:'',
                    sub17:0,
                    sub18:'',
                    sub19:0,
                    sub20:0,
                    sub22:{},
                    sub26:0,
                    sub27:0,
                    sub28:'',
                    sub31:0,
                    sub35:0,
                    sub36:0,
                    sub38:0,
                    sub39:0,
                    sub40:'',
                    sub43:0,
                    sub45:0,
                    sub47:0,
                    sub51:0,
                    sub53:0,
                    sub55:0,
                    sub58:0,
                    sub59:0,
                    sub63:0,
                    sub65:0,
                    sub66:0,
                    sub67:'',
                },
                scores:[0,0,0,0,0,0,0,0,0,0],
                possibles:[7,4,5,7,4,8,7,5,7,6],
                detailsJson:[[],[],[],[],[],[],[],[],[],[]],
                rules:{
                    sub0:[{required: true, message: 'Required', trigger: 'blur'}],
                    sub1:[{required: true, message: 'Required', trigger: 'blur'},
                        {validator:validateEmptyFour,trigger: 'blur'}],
                    sub3:[{required: true, message: 'Required', trigger: 'blur'}],
                    sub6:[{required: true, message: 'Required', trigger: 'blur'}],
                    sub8:[{required: true, message: 'Required', trigger: 'blur'}],
                    sub9:[{required: true, message: 'Required', trigger: 'blur'}],
                    sub10:[{required: true, message: 'Required', trigger: 'blur'},
                        {validator:validateEmptyFour,trigger: 'blur'}],
                    sub14:[{required: true, message: 'Required', trigger: 'blur'}],
                    sub15:[{required: true, message: 'Required', trigger: 'blur'},
                        {validator:validateEmptyFour,trigger: 'blur'}],
                    sub21:[{required: true, message: 'Required', trigger: 'blur'}],
                    sub22:[{required: true, message: 'Required', trigger: 'blur'},
                        {validator:validateEmptyFour,trigger: 'blur'}],
                    sub23:[{required: true, message: 'Required', trigger: 'blur'}],
                    sub24:[{required: true, message: 'Required', trigger: 'blur'}],
                    sub25:[{required: true, message: 'Required', trigger: 'blur'}],
                    sub29:[{required: true, message: 'Required', trigger: 'blur'}],
                    sub30:[{required: true, message: 'Required', trigger: 'blur'}],
                    sub32:[{required: true, message: 'Required', trigger: 'blur'}],
                    //#6
                    sub33:[{required: true, message: 'Required', trigger: 'blur'}],
                    sub34:[{required: true, message: 'Required', trigger: 'blur'}],
                    sub37:[{required: true, message: 'Required', trigger: 'blur'}],
                    sub41:[{required: true, message: 'Required', trigger: 'blur'}],
                    //#7
                    sub42:[{required: true, message: 'Required', trigger: 'blur'}],
                    sub44:[{required: true, message: 'Required', trigger: 'blur'}],
                    sub46:[{required: true, message: 'Required', trigger: 'blur'}],
                    sub48:[{required: true, message: 'Required', trigger: 'blur'}],
                    //#8
                    sub49:[{required: true, message: 'Required', trigger: 'blur'}],
                    sub50:[{required: true, message: 'Required', trigger: 'blur'}],
                    sub52:[{required: true, message: 'Required', trigger: 'blur'}],
                    //#9
                    sub54:[{required: true, message: 'Required', trigger: 'blur'}],
                    sub56:[{required: true, message: 'Required', trigger: 'blur'}],
                    sub57:[{required: true, message: 'Required', trigger: 'blur'}],
                    sub60:[{required: true, message: 'Required', trigger: 'blur'}],
                    //#10
                    sub61:[{required: true, message: 'Required', trigger: 'blur'}],
                    sub62:[{required: true, message: 'Required', trigger: 'blur'}],
                    sub64:[{required: true, message: 'Required', trigger: 'blur'}],
                }
            }
        },
        computed:{
            /**根据用户自己选择算出正确率**/
            correctPercent(){
                return (this.getSocre*100/this.totalNum).toFixed(2)+'%'
            },
            /**判断每个大题中是否含有小题错误**/
            isCorrectSub1(){
                var res1 = this.form.sub1.a&&this.form.sub1.b&&!this.form.sub1.c&&!this.form.sub1.d
                return this.form.sub0==2&&res1&&this.form.sub3=='6/13/2012'&&this.form.sub4==0&&this.form.sub6==48&&this.form.sub7==1
            },
            isCorrectSub2(){
                var res10 = !this.form.sub10.a&&!this.form.sub10.b&&!this.form.sub10.c&&this.form.sub10.d
                return this.form.sub8==73&&this.form.sub9==0&&res10&&this.form.sub12==0
            },
            isCorrectSub3(){
                var res15 = this.form.sub15.a&&!this.form.sub15.b&&!this.form.sub15.c&&!this.form.sub15.d
                return this.form.sub14==84&&res15&&this.form.sub17==1&&this.form.sub19==0&&this.form.sub20==1
            },
            isCorrectSub4(){
                var res22= this.form.sub22.a&&!this.form.sub22.b&&!this.form.sub22.c&&!this.form.sub22.d
                return this.form.sub21==104&&res22&&this.form.sub23==163&&this.form.sub24==104&&this.form.sub25==59&&this.form.sub26==1&&this.form.sub27==1
            },
            isCorrectSub5(){
                return this.form.sub29==589&&this.form.sub30=='90115012801'&&this.form.sub31==1&&this.form.sub32==244
            },
            isCorrectSub6(){
                var res = this.form.sub33.toLowerCase().indexOf('david')>=0&&this.form.sub33.toLowerCase().indexOf('tibbitts')>=0
                return res&&this.form.sub34=='3/30/2012'&&this.form.sub35==1&&this.form.sub36==1&&
                    this.form.sub37=='360.5'&&this.form.sub38==1&&this.form.sub39==0&&this.form.sub41==16
            },
            isCorrectSub7(){
                return this.form.sub42==230&&this.form.sub43==1&&this.form.sub44==20&&this.form.sub45==1&&this.form.sub46==125&&
                    this.form.sub47==1&&this.form.sub48==26
            },
            isCorrectSub8(){
                return this.form.sub49==526&&this.form.sub50==0&&this.form.sub51==1&&this.form.sub52==324&&this.form.sub53==0
            },
            isCorrectSub9(){
                return this.form.sub54==1734&&this.form.sub55==0&&this.form.sub56==0&&this.form.sub57==1208&&this.form.sub58==1
                &&this.form.sub59==1&&this.form.sub60==526
            },
            isCorrectSub10(){
                var res61 = this.form.sub61=='Saralynn Hansen'||this.form.sub61=='Christal Stephens'
                var res62 = (this.form.sub61=='Saralynn Hansen'&&this.form.sub62==613)||(this.form.sub61=='Christal Stephens'&&this.form.sub62==520)
                var res64 = (this.form.sub61=='Saralynn Hansen'&&this.form.sub64==138)||(this.form.sub61=='Christal Stephens'&&this.form.sub64==104)
                var res66 = (this.form.sub61=='Saralynn Hansen'&&this.form.sub66==1)||(this.form.sub61=='Christal Stephens'&&this.form.sub66==0)
                return res61&&res62&&this.form.sub63==1&&res64&&this.form.sub65==0&&res66
            },
        },
        methods:{
            goBack(){
                this.$router.push({path:'/service'})
            },
            goPre(){
                this.$router.go(-1)
            },
            calScore(){
                this.scores=[0,0,0,0,0,0,0,0,0,0]
                this.correctNum=0
                //#EOB1
                if(this.form.sub0==2){
                    this.scores[0]++;this.correctNum++
                }
                //多选题选错一个扣一分，选对一个得1分
                if(this.form.sub1.a)this.scores[0]++
                if(this.form.sub1.b)this.scores[0]++
                if(this.form.sub1.c)this.scores[0]--
                if(this.form.sub1.d)this.scores[0]--
                if(this.form.sub1.a&&this.form.sub1.b&&!this.form.sub1.c&&!this.form.sub1.d){//只有所有答案对了才算这道题是对的
                    this.correctNum++
                }
                if(this.form.sub3=='6/13/2012'){
                    this.scores[0]++;this.correctNum++
                }
                if(this.form.sub4==0){
                    this.scores[0]++;this.correctNum++
                }
                if(this.form.sub6==48){
                    this.scores[0]++;this.correctNum++
                }
                if(this.form.sub7==1){
                    this.scores[0]++;this.correctNum++
                }

                //#EOB2
                if(this.form.sub8==73){
                    this.scores[1]++;this.correctNum++
                }
                if(this.form.sub9==0){
                    this.scores[1]++;this.correctNum++
                }
                if(this.form.sub10.a)this.scores[1]--
                if(this.form.sub10.b)this.scores[1]--
                if(this.form.sub10.c)this.scores[1]--
                if(this.form.sub10.d)this.scores[1]++
                if(!this.form.sub10.a&&!this.form.sub10.b&&!this.form.sub10.c&&this.form.sub10.d){this.correctNum++}
                if(this.form.sub12==0){
                    this.scores[1]++;this.correctNum++
                }


                //#EOB3
                if(this.form.sub14==84){
                    this.scores[2]++;this.correctNum++
                }
                //what kind of a payment was made?
                if(this.form.sub15.a)this.scores[2]++
                if(this.form.sub15.b)this.scores[2]--
                if(this.form.sub15.c)this.scores[2]--
                if(this.form.sub15.d)this.scores[2]--
                if(this.form.sub15.a&&!this.form.sub15.b&&!this.form.sub15.c&&!this.form.sub15.d){
                    this.correctNum++
                }
                if(this.form.sub17==1){this.scores[2]++;this.correctNum++}
                if(this.form.sub19==0){this.scores[2]++;this.correctNum++}
                if(this.form.sub20==1){this.scores[2]++;this.correctNum++}

                //#EOB4
                if(this.form.sub21==104){this.scores[3]++;this.correctNum++}
                if(this.form.sub22.a)this.scores[3]++
                if(this.form.sub22.b)this.scores[3]--
                if(this.form.sub22.c)this.scores[3]--
                if(this.form.sub22.d)this.scores[3]--
                if(this.form.sub22.a&&!this.form.sub22.b&&!this.form.sub22.c&&!this.form.sub22.d){this.correctNum++}
                if(this.form.sub23==163){this.scores[3]++;this.correctNum++}
                if(this.form.sub24==104){this.scores[3]++;this.correctNum++}
                if(this.form.sub25==59){this.scores[3]++;this.correctNum++}
                if(this.form.sub26==1){this.scores[3]++;this.correctNum++}
                if(this.form.sub27==1){this.scores[3]++;this.correctNum++}

                //EOB5
                if(this.form.sub29==589){this.scores[4]++;this.correctNum++}
                if(this.form.sub30=='90115012801'){this.scores[4]++;this.correctNum++}
                if(this.form.sub31==1){this.scores[4]++;this.correctNum++}
                if(this.form.sub32==244){this.scores[4]++;this.correctNum++}

                //EOB6
                if(this.form.sub33.toLowerCase().indexOf('david')>=0&&this.form.sub33.toLowerCase().indexOf('tibbitts')>=0){
                    this.scores[5]++;this.correctNum++}
                if(this.form.sub34=='3/30/2012'){this.scores[5]++;this.correctNum++}
                if(this.form.sub35==1){this.scores[5]++;this.correctNum++}
                if(this.form.sub36==1){this.scores[5]++;this.correctNum++}
                if(this.form.sub37==360.5){this.scores[5]++;this.correctNum++}
                if(this.form.sub38==1){this.scores[5]++;this.correctNum++}
                if(this.form.sub39==0){this.scores[5]++;this.correctNum++}
                if(this.form.sub41==16){this.scores[5]++;this.correctNum++}

                //EOB7
                if(this.form.sub42==230){this.scores[6]++;this.correctNum++}
                if(this.form.sub43==1){this.scores[6]++;this.correctNum++}
                if(this.form.sub44==20){this.scores[6]++;this.correctNum++}
                if(this.form.sub45==1){this.scores[6]++;this.correctNum++}
                if(this.form.sub46==125){this.scores[6]++;this.correctNum++}
                if(this.form.sub47==1){this.scores[6]++;this.correctNum++}
                if(this.form.sub48==26){this.scores[6]++;this.correctNum++}

                //EOB8
                if(this.form.sub49==526){this.scores[7]++;this.correctNum++}
                if(this.form.sub50==0){this.scores[7]++;this.correctNum++}
                if(this.form.sub51==1){this.scores[7]++;this.correctNum++}
                if(this.form.sub52==324){this.scores[7]++;this.correctNum++}
                if(this.form.sub53==0){this.scores[7]++;this.correctNum++}

                //EOB9
                if(this.form.sub54==1734){this.scores[8]++;this.correctNum++}
                if(this.form.sub55==0){this.scores[8]++;this.correctNum++}
                if(this.form.sub56==0){this.scores[8]++;this.correctNum++}
                if(this.form.sub57==1208){this.scores[8]++;this.correctNum++}
                if(this.form.sub58==1){this.scores[8]++;this.correctNum++}
                if(this.form.sub59==1){this.scores[8]++;this.correctNum++}
                if(this.form.sub60==526){this.scores[8]++;this.correctNum++}

                //EOB10
                if(this.form.sub61=='Saralynn Hansen'||this.form.sub61=='Christal Stephens'){
                    this.scores[9]++;this.correctNum++}
                if(this.form.sub61=='Saralynn Hansen'&&this.form.sub62==613){this.scores[9]++;this.correctNum++}
                else if(this.form.sub61=='Christal Stephens'&&this.form.sub62==520){this.scores[9]++;this.correctNum++}
                if(this.form.sub63==1){this.scores[9]++;this.correctNum++}
                if(this.form.sub61=='Saralynn Hansen'&&this.form.sub64==138){
                    this.scores[9]++;this.correctNum++}
                else if(this.form.sub61=='Christal Stephens'&&this.form.sub64==104){
                    this.scores[9]++;this.correctNum++}
                if(this.form.sub65==0){this.scores[9]++;this.correctNum++
                }
                if(this.form.sub61=='Saralynn Hansen'&&this.form.sub66==1){
                    this.scores[9]++;this.correctNum++}
                else if(this.form.sub61=='Christal Stephens'&&this.form.sub66==0){
                    this.scores[9]++;this.correctNum++}
                var goal = 0
                this.scores.forEach(item=>{
                    goal+=item
                })
                 this.getSocre = goal
            },
            deconstructData(data){//解构已测试
                if(!data)return
                this.finishDate = data.finishDate 
                var jsonData = data.detail||[]
                var len = jsonData.length
                if(len!=10){
                    // console.log('答题数据错误')
                    return
                }
                for(var i=0;i<len;i++){
                    var item = jsonData[i].detail
                    for(var j=0;j<item.length;j++){
                        var child = item[j]
                        if(i==0){
                            if(j<8){
                                if(j==1){
                                    if(child.indexOf('a')>=0) this.form['sub'+j].a=true
                                    if(child.indexOf('b')>=0) this.form['sub'+j].b=true
                                    if(child.indexOf('c')>=0) this.form['sub'+j].c=true
                                    if(child.indexOf('d')>=0) this.form['sub'+j].d=true
                                }else{
                                    this.form['sub'+j]=child
                                }
                            }
                        }else if(i==1){
                            if(j<6){
                                if(j==2){
                                    if(child.indexOf('a')>=0) this.form['sub'+(8+j)].a=true
                                    if(child.indexOf('b')>=0) this.form['sub'+(8+j)].b=true
                                    if(child.indexOf('c')>=0) this.form['sub'+(8+j)].c=true
                                    if(child.indexOf('d')>=0) this.form['sub'+(8+j)].d=true
                                }else if(j==4){
                                    if(child=='Call Metlife'){
                                        this.form['sub'+(8+j)]=0
                                    }else if(child=='Patient Charts'){
                                        this.form['sub'+(8+j)]=1
                                    }else if(child=='Medical History'){
                                        this.form['sub'+(8+j)]=2
                                    }else if(child=='Call Patient'){
                                        this.form['sub'+(8+j)]=3
                                    }
                                    // console.log('解构:'+this.form['sub'+(8+j)])
                                }else{
                                    this.form['sub'+(8+j)] = child
                                }
                            }
                        }else if(i==2){
                            if(j<7){
                                if(j==1){
                                    if(child.indexOf('a')>=0) this.form['sub'+(14+j)].a=true
                                    if(child.indexOf('b')>=0) this.form['sub'+(14+j)].b=true
                                    if(child.indexOf('c')>=0) this.form['sub'+(14+j)].c=true
                                    if(child.indexOf('d')>=0) this.form['sub'+(14+j)].d=true
                                }else{
                                    this.form['sub'+(14+j)] = child
                                }
                            }
                        }else if(i==3){
                            if(j<8){
                                if(j==1){
                                    if(child.indexOf('a')>=0) this.form['sub'+(21+j)].a=true
                                    if(child.indexOf('b')>=0) this.form['sub'+(21+j)].b=true
                                    if(child.indexOf('c')>=0) this.form['sub'+(21+j)].c=true
                                    if(child.indexOf('d')>=0) this.form['sub'+(21+j)].d=true
                                }else{
                                    this.form['sub'+(21+j)] = child
                                }
                            }
                        }else if(i==4){
                            if(j<4) this.form['sub'+(29+j)] = child
                        }else if(i==5){
                            if(j<9) this.form['sub'+(33+j)] = child
                        }else if(i==6){
                            if(j<7)this.form['sub'+(42+j)] = child
                        }else if(i==7){
                            if(j<5)this.form['sub'+(49+j)] = child
                        }else if(i==8){
                            if(j<7)this.form['sub'+(54+j)] = child
                        }else if(i==9){
                            if(j<7)this.form['sub'+(61+j)] = child
                        }
                    }
                }
               this.calScore()
            },
            rebuildData(){//重构数据测试通过
                this.detailsJson=[[],[],[],[],[],[],[],[],[],[]]
                for(var i=0;i<68;i++){
                    if(i<8){//第1题构造detail
                        if(i==1){
                            var tempList=[],str=''
                            if(this.form['sub'+i].a)tempList.push('a')
                            if(this.form['sub'+i].b)tempList.push('b')
                            if(this.form['sub'+i].c)tempList.push('c')
                            if(this.form['sub'+i].d)tempList.push('d')
                            str = tempList.join('')
                            this.detailsJson[0].push(str)
                        }else if(i==0||i==6){
                            this.detailsJson[0].push(Number(this.form['sub'+i]))
                        }else{
                            this.detailsJson[0].push(this.form['sub'+i])
                        }
                    }else if(i>=8&&i<14){//第2题构造detail
                        if(i==10){
                            var tempList1=[],str1=''
                            if(this.form['sub'+i].a)tempList1.push('a')
                            if(this.form['sub'+i].b)tempList1.push('b')
                            if(this.form['sub'+i].c)tempList1.push('c')
                            if(this.form['sub'+i].d)tempList1.push('d')
                            str1 = tempList1.join('')
                            this.detailsJson[1].push(str1)
                        }else if(i==12){
                            if(this.form['sub'+i]==0)this.detailsJson[1].push("Call Metlife")
                            if(this.form['sub'+i]==1)this.detailsJson[1].push("Patient Charts")
                            if(this.form['sub'+i]==2)this.detailsJson[1].push("Medical History")
                            if(this.form['sub'+i]==3)this.detailsJson[1].push("Call Patient")
                        }else if(i==8||i==9){
                            this.detailsJson[1].push(Number(this.form['sub'+i]))
                        }else{
                            this.detailsJson[1].push(this.form['sub'+i])
                        }
                    }else if(i>=14&&i<21){
                        if(i==15){
                            var tempList2=[],str2=''
                            if(this.form['sub'+i].a)tempList2.push('a')
                            if(this.form['sub'+i].b)tempList2.push('b')
                            if(this.form['sub'+i].c)tempList2.push('c')
                            if(this.form['sub'+i].d)tempList2.push('d')
                            str2 = tempList2.join('')
                            this.detailsJson[2].push(str2)
                        }else if(i==14){
                            this.detailsJson[2].push(Number(this.form['sub'+i]))
                        }else{
                            this.detailsJson[2].push(this.form['sub'+i])
                        }
                    }else if(i>=21&&i<29){
                        if(i==22){
                            var tempList3=[],str3=''
                            if(this.form['sub'+i].a)tempList3.push('a')
                            if(this.form['sub'+i].b)tempList3.push('b')
                            if(this.form['sub'+i].c)tempList3.push('c')
                            if(this.form['sub'+i].d)tempList3.push('d')
                            str3 = tempList3.join('')
                            this.detailsJson[3].push(str3)
                        }else if(i==21||i==23||i==24||i==25){
                            this.detailsJson[3].push(Number(this.form['sub'+i]))
                        }else{
                            this.detailsJson[3].push(this.form['sub'+i])
                        }
                    }else if(i>=29&&i<33){//#5
                        if(i==29||i==32){
                            this.detailsJson[4].push(Number(this.form['sub'+i]))
                        }else{
                            this.detailsJson[4].push(this.form['sub'+i])
                        }
                    }else if(i>=33&&i<42){//#6
                        if(i==37||i==41){
                            this.detailsJson[5].push(Number(this.form['sub'+i]))
                        }else{
                            this.detailsJson[5].push(this.form['sub'+i])
                        }
                    }else if(i>=42&&i<49){//#7
                        if(i==42||i==44||i==46||i==48){
                            this.detailsJson[6].push(Number(this.form['sub'+i]))
                        }else{
                            this.detailsJson[6].push(this.form['sub'+i])
                        }
                    }else if(i>=49&&i<54){//#8
                        if(i==49||i==50||i==52){
                            this.detailsJson[7].push(Number(this.form['sub'+i]))
                        }else{
                            this.detailsJson[7].push(this.form['sub'+i])
                        }
                    }else if(i>=54&&i<61){//#9
                        if(i==54||i==56||i==57||i==60){
                            this.detailsJson[8].push(Number(this.form['sub'+i]))
                        }else{
                            this.detailsJson[8].push(this.form['sub'+i])
                        }
                    }else if(i>=61&&i<68){
                        if(i==62||i==64){
                            this.detailsJson[9].push(Number(this.form['sub'+i]))
                        }else{
                            this.detailsJson[9].push(this.form['sub'+i])
                        }
                    }
                }
            },
            openPdf(index){
                this.pdfVisible=true
                this.titleName="eAssist EOB Exam "+index+".pdf"
                this.pdfSrc=require('../../assets/file/EOB Exam/eAssist EOB Exam '+index+'.pdf')

            },
            nextStep(){
                var flags = this.$store.state.finished
                if(flags['Radio']==0){
                    this.$emit('changeIndex','1')
                    this.$emit('changeEobStatus')
                    window.scrollTo(0,0);
                }else if(flags['Claim']==0){
                    this.$emit('changeIndex','2')
                    this.$emit('changeEobStatus')
                    window.scrollTo(0,0);
                }else{
                    this.completionDialogVisible = true
                }
            },
            handleCompletionConfirm() {
                this.completionDialogVisible = false
                this.goBack()
            },
            submit(){
                var score=0,possible=0
                this.calScore()
                // console.log('submit score',this.scores)
                score= this.scores.reduce(function(sum,number){ //sum2 前两个数的和
                    return sum + number;
                },0)
                possible= this.possibles.reduce(function(sum,number){ //sum2 前两个数的和
                    return sum + number;
                },0)
                this.confirmVisible=false
                this.rebuildData()
                // console.log('submit data',this.detailsJson)
                var paramsList = []
                for(var i=0;i<10;i++){
                    var obj={}
                    obj.score= this.scores[i]
                    obj.possible = this.possibles[i]
                    obj.detail = this.detailsJson[i]
                    paramsList.push(obj)
                }
                 var storeService = this.$store.state.serviceInfo
                 //var positionInfo = this.$store.state.positionInfo
                 var params={}
                params.serviceId =storeService.serviceId
                params.versionId = storeService.serviceVersion
                params.score = score
                params.possible = possible//textarea不算分数
                params.positionId = 0
                params.type='EOB'
                // params.status = score>storeService.servicePassScore
                params.detail = JSON.stringify(paramsList)
                params.applicantEmail=localStorage.getItem('email')
                // console.log('传参',params)
                this.pdfLoading=true
                this.$axios.post(this.$URL.dentalbillingUrl,params).then(res=>{
                    this.pdfLoading=false
                    if(res.code==0){
                        var finishModule = this.$store.state.finished
                        finishModule['EOB']=1
                        this.showResult=true
                        this.$store.commit('saveFinishModule',finishModule)
                        this.nextStep()
                    }else{
                        this.$message.error({message:res.msg})
                    }
                }).catch(err=>{
                    this.pdfLoading=false
                    this.$message.error({message:err})
                })
            },
            submitPrepare(){
                // console.log('提交',this.form)
                this.$refs['form'].clearValidate()
                this.$nextTick(() => {
                    this.$refs['form'].validate((valid,object) => {
                        if (valid) {
                           this.confirmVisible=true
                        }else {
                            var obj = Object.keys(object)[0]
                            let dom = this.$refs[obj]
                            dom.$el.scrollIntoView({
                                //滚动到指定节点
                                block: 'center', //值有start,center,end，nearest，当前显示在视图区域中间
                                behavior: 'smooth' //值有auto、instant,smooth，缓动动画（当前是慢速的）
                            })
                            // console.log('error submit!!');
                            return false;
                        }
                    })
                })
            },
            cancel(){
                this.exitVisible=true
            },
            getDentalBilling(email){
                // console.log("start =============== isAdmin", this.isAdmin);
                this.pdfLoading=true
                this.$axios.get(this.$URL.dentalbillingUrl,{params:{email:email,type:'EOB'}}).then(res=>{
                    this.pdfLoading=false
                    if(res&&res.code==0){
                        this.hasFinished=true
                        var data = res.data
                        var finishModule = this.$store.state.finished
                        if(data&&data.detail!=null){
                            console.log('EOB 测试已经做了！')
                            finishModule['EOB']=1
                            if(this.isAdmin)this.showResult=false
                            else this.showResult=true
                            this.deconstructData(data)
                            this.$emit('changeStatus')
                        }else{
                            finishModule['EOB']=0
                            // console.log('EOB 测试还没做！')
                            this.showResult=false
                        }
                        this.$store.commit('saveFinishModule',finishModule)
                        // console.log('已做过2',this.$store.state.finished)
                    }else{
                        this.$message.error({message:res.msg})
                    }
                }).catch(err=>{
                    this.pdfLoading=false
                    this.$message.error({message:err})
                })
                // console.log("end =============== isAdmin", this.isAdmin);
            }
        },
        created() {
            var email
            if(this.$route&&this.$route.query.model=='review'&&this.$route.query.verify){
                this.isAdmin=true
                this.showResult=false
                email = this.$route.query.email
            }else{
                email = localStorage.getItem('email')
                this.isAdmin=false
                this.showResult=false
            }
            this.getDentalBilling(email)
        },
    }
</script>

<style scoped>
    .el-select >>> .el-input{
        width: 68px;
    }
    .longSelect >>> .el-input{
        width: 140px;
    }
    .el-select >>> .el-input .el-input__inner{
        background: #fff!important;
        font-size: 12px!important;
        line-height: 36px!important;
        border-radius: 0px!important;
        vertical-align: middle;
        height: 36px!important;
    }
    .el-select >>> .el-input .el-input__icon{
        width: 15px!important;
    }
    .el-radio{
        height: 30px!important;
    }
    .smallBox >>>.el-form-item__content{
        line-height: 25px!important;
    }
    .minH150{
        min-height: 150px;
    }

    .minH200{
        min-height: 150px;
    }
    .titleInner{
        width: 35%;
        line-height: 20px;
        margin-top: 10px
    }
    .textarea{
        resize:none;
        width: 30%;
        position: absolute;
        top:15px;
        margin-left: 37%;
        height: 50px
    }
    .radioGroup{
        position: absolute;
        top:10px;
        margin-left: 37%
    }
    .select{
        position: absolute;
        top:8px;
        margin-left: 37%
    }
    .el-image{
        overflow: inherit;
    }
    .key{
        border: 1px solid red;
        width: 20%;
        position: absolute;
        top: 15px;
        font-size: 12px;
        right: 20px;
    }
    .key1{
        border: 1px solid red;
        position: absolute;
        top: 15px;
        width:14%;
        right: 120px;
        font-size: 12px
    }
    .key2{
        border: 1px solid red;
        position: absolute;
        top: 15px;
        width:14%;
        right: -20px;
        font-size: 12px
    }
    .between{
        top:18px;
        right: 110px;
        position: absolute;
    }
    .el-input>>>.el-input__inner{
        font-size: 14px!important;
    }
    @media screen and (max-width: 1200px) {
        .viewPDF{
            left: 20%;
        }
        .viewPDF span{
            font-size: 14px;
        }
        .titleInner{
            width: 35%;
        }
        .textarea,.radioGroup,.select{
            margin-left: 37%;
        }
        .key1,.key2{
            width:18%;
        }
        .key1{
            right: 100px;
        }
        .between{
            right: 90px;
        }
    }
</style>
